// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"ring-global-ellipsis","link":"BreadcrumbsLink__link--ZY ring-global-ellipsis","rightIcon":"BreadcrumbsLink__rightIcon--0V"};